// Reglas de los formularios de Negocios (negocio, tienda y usuario retail) con los validadores centrales.
import { z } from 'zod';
import {
    emailField,
    mxPhoneField,
    mxZipCodeField,
    optionalMxPhoneField,
    rfcField,
} from '@/lib/formValidators';

const required = (message: string) => z.string().trim().min(1, message);

const retailerAddressFields = {
    address1: required('Escribe la calle.'),
    externalNumber: z.string().trim(),
    neighborhood: z.string().trim(),
    city: required('Escribe la ciudad.'),
    state: required('Escribe el estado.'),
    zipCode: mxZipCodeField(),
};

/** Edición de negocio: el RFC y el nombre no se editan, así que no se revalidan. */
export const retailerEditSchema = z.object({
    legalName: required('Escribe la razón social.'),
    contactEmail: emailField(),
    contactPhone: mxPhoneField(),
    ...retailerAddressFields,
});

/** Alta de negocio o subdistribuidor. */
export const retailerCreateSchema = retailerEditSchema.extend({
    name: required('Escribe el nombre comercial.'),
    rfc: rfcField(),
});

export type RetailerFormField = keyof z.input<typeof retailerCreateSchema>;

/** Tienda del detalle de negocio: teléfono y C.P. con el formato MX. */
export const retailStoreContactSchema = z.object({
    phone: mxPhoneField(),
    zipCode: mxZipCodeField(),
});

/** Usuario retail: el correo solo se valida en el alta; el teléfono es opcional. */
export const retailUserCreateSchema = z.object({
    email: emailField(),
    phone: optionalMxPhoneField,
});

export const retailUserEditSchema = retailUserCreateSchema.pick({ phone: true });
